<script lang="ts">
	import { tick, type Snippet } from 'svelte';

	let loading = $state(false);

	export type AsyncActionResult = Promise<{ keep_loading_state: boolean } | void>;

	let {
		action,
		children
	}: {
		action: () => AsyncActionResult;
		children: Snippet<[loading: boolean, run: () => Promise<void>]>;
	} = $props();

	async function run() {
		if (loading) return;
		loading = true;
		await tick();
		try {
			const result = await action();
			if (typeof result === 'object' && result.keep_loading_state) {
				return;
			}
			loading = false;
		} catch {
			loading = false;
		}
	}
</script>

{@render children(loading, run)}
